import Nav from "../../general/nav.jsx";
import HeroFooter from "../../general/heroFooter.jsx";
import Imghero from "../../../assets/img/projects/People/People-logo.png";
import { useTranslation } from "react-i18next";

function Hero() {
  const { t } = useTranslation();

  return (
    <div className="people hero" id="hero">
      <Nav />
      <img className="ImgHero" src={Imghero} alt="People Restaurant Hero" />
      <HeroFooter
        name={t("people.hero.name")}
        link1url="https://www.people.restaurant/"
        link2display={true}
        link2name={t("people.hero.link2")}
        link2url="https://www.instagram.com/people.restau/"
      />
    </div>
  );
}

export default Hero;
